export const reporting_Manager = [
  //  {name:'Manisha Sharma',email:'manisha.sharma@itradiant.com'},
  // {name:'Sai Teja Goli',email:'golisai.teja@itradiant.com'},
  
  { name: "Priyanka Lohani", email: "priyanka.lohani@itradiant.com" },
  // { name: "Lavina Lalwani", email: "lavina.l@itradiant.com" },
  //  {name:'Vivek Khandelwal',email:'vivek.khandelwal@itradiant.com'},
  //   {name:'Pulkit Bopche',email:'pulkit.bopche@itradiant.com'},
  //   {name:'Rachna Bagaria',email:'rachna@itradiant.com'},
  //   {name:'Srikanth Myneni',email:'srikanth.myneni@itradiant.com'},
  /* {name:'Neeraj Maurya',email:'Neeraj.maurya@itradiant.com'}, */
];
export const Finance = [
  { name: "Lavina Lalwani", email: "lavina.l@itradiant.com" },
  // {name:'Deepsmita Khadanga',email:'deepsmita.khadanga@itradiant.com'},
  // {name:'Sai Teja Goli',email:'golisai.teja@itradiant.com'},

  /* {name:'Neeraj Maurya',email:'Neeraj.maurya@itradiant.com'}, */
];

export const Higher_authority = [
  { name: "KC Sahu", email: "kcsahu@itradiant.com" },
  //       {name:'Neeraj Maurya - [d]',email:'deepsmita878@gmail.com'},
  // {name:'Sai Teja Goli',email:'golisai.teja@itradiant.com'},

  /* {name:'Neeraj Maurya',email:'Neeraj.maurya@itradiant.com'}, */
  /*{name:'Pulkit Bopche',email:'pulkit.bopche@itradiant.com'},
    {name:'Abhishek',email:'abhishek@gmail.com'},
    {name:'HR',email:'hr@itradiant.com'},*/
  /* {name:'Neeraj Maurya',email:'Neeraj.maurya@itradiant.com'},  */
];

/* export const Vendor = [
    {name:'Neeraj Maurya',email:'neeraj.maurya@itradiant.com',address:'4-6 Riverwalk Citywest Business Park Dublin 24 Ireland',phone:'123456789',gst_no:'36AAACB2894G1ZO' },
    {name:'vendor2',email:'vendor2@gmail.com',address:'U.S',phone:'0987654321',gst_no:'987654'},
    {name:'vendor3',email:'vendor3@gmail.com',address:'Dubai',phone:'0192837465',gst_no:'23412'}
]
 */

export const Ship_to = [
  {
    CompanyID: "U72900TG2018PTC125455",
    CompanyName: "IT Radiant Solutions Private Limited",
    address: "SUITE NO 506, JAIN SADGURU IMAGES CAPITOL PARK",
    nearby: "IMAGE GARDEN ROAD, Madhapur, Hyderabad, Rangareddy",
    GSTIN: "36AAJCR0345K1Z8",
    state: "Telangana",
    postalCode: "500081",
    country: "India",
  },
];

export const Company = [
  { address: "ITRadiant India" },
  { address: "ITRadiant US" },
  { address: "Itradiant Dubai" },
];

// export const productCategories = {
//     Housekeeping: [
//       "Paper cup",
//       "Tissue Packet",
//       "Dustbin Cover",
//       "Garbage Bags",
//       "Dry Mop",
//       "Wet Mop",
//       "Roomfreshener",
//       "R2(Chemical)",
//       "Micro cloth",
//       "Colin",
//       "Dishwash Liquid",
//       "Handwash",
//       "Scotch Pad",
//       "Harpic",
//       "Wiper",
//       "WC Brush",
//       "Paper plates",
//       "Candels",
//       "Coffee Stirers",
//       "Broom",
//       "Colour print",
//     ],
//     Stationary: [
//       "Ball Pen",
//       "Notebook",
//       "Stapler",
//       "A4 paper",
//       "Stapler pin",
//       "Pencil",
//       "Eraser packet",
//       "Marker(stamp)",
//       "Marker Permanent",
//       "Scale/Ruler",
//       "Duster",
//       "Correction ink pen",
//       "Register",
//       "Sketch Pen",
//       "Highlighter Pen",
//       "Punching Machine",
//       "Sticky Note",
//       "Scissors",
//       "Cellotape",
//       "BrownTape",
//       "Transparent File",
//       "Paper file",
//       "Bond paper",
//       "Fevi stik",
//       "AA pencil cell for watches",
//       "Paper cutter",
//       "Alpin",
//       "Gem clips",
//       "Push Board Pins",
//       "Double tape",
//       "Blue Tac",
//       "Balloons for Decorations",
//       "Magic Candles",
//       "Match box",
//       "Envelopes-Big",
//       "Envelopes-Small",
//       "Company letter Head",
//       "Company continuation sheet",
//       "Visiting card folder",
//       "Cell",
//     ],
//     Eatables: [
//       "Snacks",
//       "Juices",
//       "Coffee Beans",
//       "Fruits",
//       "Tea sachets",
//       "Sugar",
//       "Biscuits",
//       "Salt",
//       "Cake",
//       "Cookies",
//       "Milks",
//       "Water cans",
//       "Water Bottles",
//     ],
//     Electric: ["Adapter", "Lights"],
//     Decoration: ["Pot", "Plants", "Paintings", "Flower"],
//   };

export const Tax = [
  { tax: "5%" },
  { tax: "10%" },
  { tax: "15%" },
  { tax: "18%" },
  { tax: "20%" },
  { tax: "28%" },
];
